import {normalizeCurrencyMinorUnit} from '../../../utils/currency';
import {makeGraphQLQuery} from '../request.gql';

export const queryFrontendConfiguration = async ({token}) => {
    const {r, e} = await makeGraphQLQuery({
        query: `query {
            configuration {
                currencyMinorUnit
                currency
                features {
                    type
                    enabled
                }
            }
        }`,
        token,
    });
    if (e) return e;
    return {
        currencyMinorUnit: normalizeCurrencyMinorUnit(r?.configuration?.currencyMinorUnit),
        currency: r?.configuration?.currency || '',
        showBaseCurrency: r?.configuration?.features?.some(feature => feature.type === 'SHOW_BASE_CURRENCY' && feature.enabled === true) === true,
    };
};
